export class ChatConstants {
  static typingStatusTimeout = 10000;
}
